import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretUp16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCaretUp16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.132 11.215a.5.5 0 0 1 0-.707l5.515-5.516.354-.353.353.353 5.514 5.514a.5.5 0 0 1-.707.707L8 6.053l-5.162 5.162a.5.5 0 0 1-.707 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretUp16);
